
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 7v1.406c-4.965 1.281-8.59 5.676-8.875 10.969C2.953 19.785 2 20.695 2 22v3h28v-3c0-1.305-.953-2.215-2.125-2.625-.285-5.293-3.91-9.688-8.875-10.969V7zm2.031 2H17a.994.994 0 000 .344V15h2v-4.5c3.738 1.18 6.566 4.473 6.969 8.5H24v2h3c.566 0 1 .434 1 1v1H4v-1c0-.566.434-1 1-1h3v-2H6.031c.403-4.027 3.23-7.32 6.969-8.5V15h2V9.5c.05-.16.063-.332.031-.5z"}})])
          )
        }
      }
    